import * as React from 'react';

import classNames from 'classnames';

import styles from './list-item.module.css';

export type Props = {
    children: React.ReactNode;
    actions?: React.ReactNode[];
    justifyContent?: 'space-between';
    noPadding?: boolean;
    noActionsPadding?: boolean;
    renderAsDiv?: boolean;
};

/**
 * This is the preferred way to create generic list of items in
 * nutshell with an avatar, two lines of information, and optional actions.
 */
export function ListItem(props: Props) {
    const styleName = classNames({
        [styles['list-item']]: true,
        [styles['list-item--default-padding']]: !props.noPadding,
        [styles['list-item--space-between']]: props.justifyContent === 'space-between',
    });

    const actionsStyleName = classNames(styles.actions, {
        [styles['actions--no-padding']]: props.noActionsPadding,
    });

    const Element = props.renderAsDiv ? 'div' : 'li';

    return (
        <Element className={styleName}>
            {props.children}
            {props.actions ? <div className={actionsStyleName}>{props.actions}</div> : undefined}
        </Element>
    );
}
